import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Timestamp = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.5 3.8199C8.5 3.54376 8.27614 3.3199 8 3.3199C7.72385 3.3199 7.5 3.54376 7.5 3.8199V8C7.5 8.13261 7.55268 8.25978 7.64644 8.35355L9.96872 10.6758C10.164 10.8711 10.4806 10.8711 10.6758 10.6758C10.8711 10.4806 10.8711 10.164 10.6758 9.96872L8.5 7.79289V3.8199Z"
      />
    </svg>
  )
})

export default Timestamp
